export const UPDATE_PROFILE = 'user/UPDATE_PROFILE';
export const LOGOUT = 'user/LOGOUT';
export const LOGIN = 'user/LOGIN';
export const AUTHORIZE = 'user/AUTHORIZE';



// WEBPACK FOOTER //
// ./src/actionTypes.js